import React from 'react';
import { Experience } from './components/Experience';
import { ExperienceProvider } from './contexts/ExperienceContext';
type EntryRoute = 'ask' | 'new' | 'better' | 'existing';
type NeedsLayout = 'ribbon' | 'orbit';
interface AppProps {
  /** Jump straight into one of the three journeys instead of the entry question. */
  entryRoute?: EntryRoute;
  /** How the family is explored: a horizontal journey or a rotating wheel. */
  needsLayout?: NeedsLayout;
  /** Show the panel that reveals what the session has remembered. */
  showSessionMemory?: boolean;
}
export function App({
  entryRoute = 'ask',
  needsLayout = 'ribbon',
  showSessionMemory = true
}: AppProps) {
  return <ExperienceProvider key={entryRoute} initialRoute={entryRoute === 'ask' ? undefined : entryRoute} data-id="element-0" data-mp="2wka18t6cn33b">
      <Experience needsLayout={needsLayout} showSessionMemory={showSessionMemory} data-id="element-1" data-mp="28tmfp53igeya" />
    </ExperienceProvider>;
}